import { type ComponentType, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { useLocation } from "react-router-dom"
import Loading from "./Loading"

type PrivateRouteProps = {
  component: ComponentType
}

const PrivateRoute = ({
  component: Component,
  ...props
}: PrivateRouteProps) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()
  const location = useLocation()

  useEffect(() => {
    // If not loading and not authenticated, redirect to login
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: `${location.pathname}${location.search}${location.hash}`,
        },
      })
    }
  }, [
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    location.pathname,
    location.search,
    location.hash,
  ])

  if (isLoading) {
    return <Loading />
  }

  // Show loading while redirecting (prevents content flash)
  if (!isAuthenticated) {
    return <Loading />
  }

  // User is authenticated - render the component
  return <Component {...props} />
}

export default PrivateRoute
